import * as React from 'react';
import { ProgramReviewIcon } from 'components/NewDashboard/icons/ProgramReviewIcon';
import { fetchProgramReviewsCount } from 'slices/programReviews';
import { ToDoDescriptor } from '../types';
import { useAppDispatch, useTypedSelector } from '../../../../combineReducers';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type RouteParams = {
  organizationId: string;
};

export const useProgramReviewsToDo = (): ToDoDescriptor[] => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<RouteParams>();
  const { t } = useTranslation('subscriber');
  const { count, isFetching } = useTypedSelector(state => state.programReviews);

  React.useEffect(() => {
    if (organizationId) {
      dispatch(fetchProgramReviewsCount(organizationId));
    }
  }, [organizationId, dispatch]);

  const reviewsCount = count || 0;

  return [
    {
      id: 'programReviews',
      variant: 'link',
      label: t('newDashboard.toDoWidget.reviewPrograms', 'Review Programs'),
      icon: <ProgramReviewIcon />,
      href: `/organizations/${organizationId}/safety-program-requirements`,
      count: reviewsCount,
      isVisible: reviewsCount > 0,
      isFetching
    }
  ];
};
